import Organization from '../types/organization';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOrganizationApi } from '../data/organization/api';

/**
 * Custom hook that handles fetching initial organization-related data on component mount
 * and potentially on page refresh.
 */
export function useRefreshHandler(): void {

  const location = useLocation();
  const orgApi = useOrganizationApi();

  /**
   * useEffect hook that runs only once after the initial render (componentDidMount).
   * It calls the manageInitialOrgSetUp function to fetch initial data.
   */
  useEffect(() => {
    manageInitialOrgSetUp();
  }, []);

  /**
   * Fetches initial organization-related data required for the application to function.
   * This includes fetching the list of licenses, features, and organizations.
   * It also checks if there was a selected organization in the previous state (likely from a navigation)
   * and fetches its details if available. This is primarily intended to restore the selected
   * organization's details after a page refresh.
   */
  const manageInitialOrgSetUp = () => {
    orgApi.fetchLicenceList();
    orgApi.fetchFeatureList();
    orgApi.fetchOrganizationList().then(data => {
      // Check whether there is any selected organisation. If so, call the respective
      // organisation detail API. This will be called only on page refresh.
      if (data) {
        const organization: Organization = location.state;
        if (organization && organization.details.id) {
          orgApi.fetchOrganizationDetail(organization.details.id);
        }
      }
    });
  }

}